module.exports = __webpack_public_path__ + "img/about_us_banner_mobile.4264dd7d.png";